import "./App.css";
import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Header from "./components/H&F/Header";
import Footer from "./components/H&F/Footer";
import Login from "./Pages/Login.jsx";
import Admin from "./Pages/Admin.jsx";
import Report from "./components/Reports/Report.jsx";
import Signup from "./Pages/Signup.jsx";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("userdetails"));
  localStorage.setItem("manualLogout", "true");
  const manualLogout = localStorage.getItem("manualLogout") === "true";
  if (!user) {
    if (!manualLogout) {
      alert("Session expired or not logged in. Redirecting to login.");
    }
    localStorage.removeItem("manualLogout");
    return <Navigate to="/" replace />;
  }
  return children;
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const user = localStorage.getItem("userdetails");
    setIsLoggedIn(!!user);
  }, []);

  return (
    <div className="app">
      <Router>
        <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/Admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Report />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
};

export default App;
